import { render, staticRenderFns } from "./ressources.vue?vue&type=template&id=cede8668&scoped=true&"
import script from "./ressources.vue?vue&type=script&lang=js&"
export * from "./ressources.vue?vue&type=script&lang=js&"
import style0 from "./ressources.vue?vue&type=style&index=0&id=cede8668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cede8668",
  null
  
)

export default component.exports